import { useNavigate, useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import {
  useGetAllPropertyMappingsForParcel,
  useGetParcelSetting,
  useUpdatePropertyMappingsForParcel,
} from '../../../hooks/api/use-arcgis-civil3d-parcel-settings.hook';
import {
  ArcgisCivil3dParcelSettingApiModel,
  ArcgisCivil3dParcelSettingRelationship,
} from '../../../../../types/models/arcgis-civil3d-parcel-setting.model';
import { PropertyMappings } from './PropertyMappings';
import { LoadingIndicator } from '../../LoadingIndicator';
import { Civil3dFeatureTypeCategory } from '../../../../../types/constants/civil3d-feature-type';
import { WithConfiguration } from '../../../../../types/models/arcgis-civil3d-setting.model';

export const ParcelPropertyMappings = () => {
  const navigate = useNavigate();
  const { parcelId } = useParams<{ parcelId: string }>();

  const [updatePropertyMappings, { error: updatePropertyMappingsError }] = useUpdatePropertyMappingsForParcel();
  const {
    parcel,
    loading: loadingParcel,
    error: getParcelError,
  } = useGetParcelSetting<ArcgisCivil3dParcelSettingApiModel & WithConfiguration>({
    parcelId: Number(parcelId),
    include: [ArcgisCivil3dParcelSettingRelationship.CONFIGURATION],
  });
  const {
    propertyMappings,
    loading: loadingPropertyMappings,
    error: propertyMappingsError,
  } = useGetAllPropertyMappingsForParcel({
    parcelId: Number(parcelId),
  });
  const error = getParcelError || propertyMappingsError || updatePropertyMappingsError;
  if (error || propertyMappingsError) {
    return <Alert severity="error">{(error || propertyMappingsError)?.response?.data.message}</Alert>;
  }

  return loadingParcel || loadingPropertyMappings || !parcel || !propertyMappings ? (
    <LoadingIndicator />
  ) : (
    <PropertyMappings
      settingName={parcel?.name}
      templateId={parcel?.configuration.template.id}
      featureClassId={parcel?.arcgisFeatureClass.id}
      featureTypeCategoryName={Civil3dFeatureTypeCategory.FEATURE_LINE}
      propertyMappings={propertyMappings}
      onSave={async ({ propertyMappings: propertyMappingsToSave }) => {
        await updatePropertyMappings({
          parcelId: Number(parcelId),
          propertyMappings: propertyMappingsToSave.filter(({ attributeId }) => Boolean(attributeId)),
        });
        navigate('..');
      }}
    ></PropertyMappings>
  );
};
